module.exports = __webpack_public_path__ + "static/media/envelope-add.1683a36e.svg";